import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Ubicacion } from 'src/app/models/Ubicacion';
import { UsuarioService } from 'src/app/services/usuario.service';
import { firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-my-account-ubicaciones',
    templateUrl: './my-account-ubicaciones.component.html',
    styleUrls: ['./my-account-ubicaciones.component.css'],
    standalone: false
})
export class MyAccountUbicacionesComponent implements OnInit{
  private _usuarioService = inject(UsuarioService);
  private _authService = inject(AuthService);
  private _loadingService = inject(LoadingService);
  private _router = inject(Router);
  private _location = inject(Location);

  // ------- estado -------
  ubicaciones = signal<Ubicacion[]>([]);
  id_perfil = signal<number>(0);

  error = signal<string>('');
  message = signal<string>('');
  loading = computed(() => this._loadingService.isLoading());

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        await this._router.navigate(['/sign-in']);
        return;
      }

      this.id_perfil.set(this._usuarioService.usuario().id_perfil ?? 0);

      try {
        const res = await firstValueFrom(
          this._usuarioService.getUbicaciones(this._usuarioService.usuario().id!)
        );
        this.ubicaciones.set(res ?? []);
      } catch (e: any) {
        console.error(e);
        this.error.set('Error al obtener las ubicaciones.');
      }
    });
  }

  async activarDesactivar(event: Event): Promise<void> {
    this.error.set('');
    this.message.set('');

    const input = event.target as HTMLInputElement;
    const id = Number(input.id);
    const checked = input.checked;

    const list = this.ubicaciones();
    const ubicacion = list.find((x) => x.id === id);

    if (!ubicacion) return;

    // optimistic UI
    ubicacion.b_activo = checked;
    this.ubicaciones.set([...list]);

    await this._loadingService.run(async () => {
      try {
        await firstValueFrom(this._usuarioService.updateUbicacion(ubicacion));

        this.message.set('Modificación realizada correctamente');
        setTimeout(() => this.message.set(''), 2500);
      } catch (e) {
        console.error(e);

        // rollback
        ubicacion.b_activo = !checked;
        this.ubicaciones.set([...list]);

        this.error.set('Error al realizar la modificación');
      }
    });
  }

  back() {
    this._location.back();
  }

  // helpers de texto
  tituloPlural(): string {
    const p = this.id_perfil();
    return (p === 1 || p === 3 || p === 4) ? 'Ubicaciones' : 'Direcciones';
  }

  tituloSingular(): string {
    const p = this.id_perfil();
    return (p === 1 || p === 3 || p === 4) ? 'Ubicación' : 'Dirección';
  }
}
